import { useCompanySettingsActions } from '@hooks/settings/company/useCompanyActions';
import type React from 'react';
import MemberDataModal from './MemberDataModal';

export const AddMemberModal: React.FC = () => {
  const { addMember } = useCompanySettingsActions();

  return <MemberDataModal onSubmit={addMember} />;
};

export default AddMemberModal;
